import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';

import { ExportQuery, fetchTopReportRows } from '~/components/GHAParticipationReport/exportReport';

import { GHAParticipationReportParams, getGHAParticipationReport } from '~/services/PublicOfferFeedService';

export const ghaParticipationReportQueryKeys = {
  all: ['ghaParticipationReport'] as const,
  lists: () => [...ghaParticipationReportQueryKeys.all, 'list'] as const,
  list: (params: GHAParticipationReportParams) => [...ghaParticipationReportQueryKeys.lists(), params] as const,
};

export function useGetGHAParticipationReport(params: GHAParticipationReportParams) {
  return useQuery({
    queryKey: ghaParticipationReportQueryKeys.list(params),
    queryFn: ({ signal }) => getGHAParticipationReport(params, { signal }),
    placeholderData: keepPreviousData,
  });
}

export function useExportGHAParticipationReport() {
  return useMutation({
    mutationFn: ({ query, rowCount }: { query: ExportQuery; rowCount: number }) => fetchTopReportRows(query, rowCount),
  });
}
